


export default {
  //API_URL: 'http://localhost:8800/api2/'
  //API_URL: 'http://cloud.smldatacenter.com:1793/api2/'
  //API_URL: 'http://cloud.smldatacenter.com:1795/api2/'
  // API_URL: 'http://cloud.smldatacenter.com:8808/api2/'
   API_URL: process.env.VUE_APP_API_URL //'http://api.dev.cocopayday.com/api2/'
}